// extracted by mini-css-extract-plugin
module.exports = {"form":"VoucherForm_form__0TVHk","submit":"VoucherForm_submit__YzzdL","input":"VoucherForm_input__UQH5Q"};